import React from 'react';
import { Icon } from '../icon/Icon.jsx';
import { Button } from '../controls/Button.jsx';

/* Plain language, technical detail behind a Details disclosure, retry where retry
   is meaningful. Never a raw stack trace, never an error code alone. */

export function ErrorPanel({ message, detail, onRetry, style }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', gap: 'var(--space-12)',
      background: 'var(--bg-surface)', border: '1px solid var(--border-default)',
      borderRadius: 'var(--radius-panel)', padding: 'var(--pad-panel)', ...style,
    }}>
      <div style={{ display: 'flex', gap: 'var(--space-12)', alignItems: 'flex-start' }}>
        <Icon name="circle-alert" size={16} style={{ color: 'var(--loss)', marginTop: 4 }} />
        <p style={{ margin: 0, flex: 1, fontSize: 'var(--body-size)', lineHeight: 'var(--body-line)', color: 'var(--text-primary)' }}>{message}</p>
        {onRetry ? <Button density="compact" onClick={onRetry}>Retry</Button> : null}
      </div>
      {detail ? (
        <details>
          <summary style={{ cursor: 'pointer', fontSize: 'var(--caption-size)', color: 'var(--text-secondary)' }}>Details</summary>
          <pre style={{
            margin: 'var(--space-8) 0 0', padding: 'var(--space-12)', background: 'var(--bg-inset)',
            borderRadius: 'var(--radius-control)', overflow: 'auto',
            fontFamily: 'var(--font-mono)', fontSize: 'var(--code-size)', lineHeight: 'var(--code-line)',
            color: 'var(--text-secondary)',
          }}>{detail}</pre>
        </details>
      ) : null}
    </div>
  );
}
